import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const CookiePolicyPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="cookie-policy-page">
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-24 md:py-32">
        <a href="/" data-testid="cookie-back" className="inline-flex items-center gap-2 text-electric hover:text-electric-hover text-sm font-medium mb-10 font-body">
          <ArrowLeft size={16} />Volver al inicio
        </a>
        <h1 className="text-3xl md:text-4xl font-black text-navy font-heading mb-8">Pol&iacute;tica de Cookies</h1>
        <p className="text-slate-400 text-sm mb-10 font-body">&Uacute;ltima actualizaci&oacute;n: Enero 2026</p>

        <div className="prose-custom space-y-8 text-slate-600 text-sm leading-relaxed font-body">
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">1. &iquest;Qu&eacute; son las cookies?</h2>
            <p>Las cookies son peque&ntilde;os archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Se utilizan para recordar tus preferencias, mejorar la experiencia de navegaci&oacute;n y analizar el uso del sitio.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">2. &iquest;Qu&eacute; cookies utilizamos?</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-navy mb-1">Cookies esenciales</h3>
                <p>Son necesarias para el funcionamiento b&aacute;sico del sitio web. Incluyen la cookie de preferencia de cookies (okontainers_cookies) y la cookie de idioma.</p>
              </div>
              <div>
                <h3 className="font-semibold text-navy mb-1">Cookies anal&iacute;ticas</h3>
                <p>Nos ayudan a entender c&oacute;mo los visitantes interact&uacute;an con el sitio web, recopilando informaci&oacute;n de forma an&oacute;nima. Utilizamos PostHog para este fin.</p>
              </div>
            </div>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">3. &iquest;C&oacute;mo gestionar las cookies?</h2>
            <p>Puedes gestionar tus preferencias de cookies en cualquier momento a trav&eacute;s del banner de cookies que aparece al visitar nuestro sitio. Tambi&eacute;n puedes configurar tu navegador para bloquear o eliminar cookies.</p>
            <p className="mt-2">Si decides rechazar las cookies no esenciales, el sitio web seguir&aacute; funcionando correctamente, pero algunas funcionalidades anal&iacute;ticas no estar&aacute;n disponibles.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">4. Duraci&oacute;n de las cookies</h2>
            <div className="bg-slate-50 rounded-xl p-5">
              <table className="w-full text-sm">
                <thead><tr className="text-left text-navy font-semibold"><th className="pb-3">Cookie</th><th className="pb-3">Tipo</th><th className="pb-3">Duraci&oacute;n</th></tr></thead>
                <tbody className="text-slate-600">
                  <tr className="border-t border-slate-200"><td className="py-2">okontainers_cookies</td><td>Esencial</td><td>Permanente</td></tr>
                  <tr className="border-t border-slate-200"><td className="py-2">posthog</td><td>Anal&iacute;tica</td><td>1 a&ntilde;o</td></tr>
                </tbody>
              </table>
            </div>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">5. Contacto</h2>
            <p>Si tienes preguntas sobre nuestra pol&iacute;tica de cookies, cont&aacute;ctanos en <a href="mailto:info@okontainers.com" className="text-electric hover:underline">info@okontainers.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
